import { AxiosRequestConfig } from "axios";
import apiService from "../services/apiService";
import { Field, Fieldset } from "../types";
import { updateText, updateValue } from "./apiHelpers";
import dayjs from "dayjs";
import apiServiceDoc from "@services/services/apiServiceDoc";

export const validateFieldset = (
  set: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
): boolean => {
  let isValid = true;

  const validateFields = (fields: Field[]): Field[] => {
    return fields.map((field: Field) => {
      let hasValue = field.value !== undefined && field.value !== "";
      let hasRequired = field.required;
      let response = "validate";

      if (hasRequired && !field.disabled) {
        if (field.type === "checkbox") {
          if (
            fields.find((c: Field) => c.type === "checkbox" && c.value !== "")
          ) {
            hasValue = true;
          }
        } else if (field.type === "typography") {
          hasValue = true;
        }
      } else if (hasRequired && field.disabled) {
        if (!hasValue) {
          response = "";
          if (field.type === "checkbox") {
            if (
              fields.find((c: Field) => c.type === "checkbox" && c.value !== "")
            ) {
              hasValue = true;
            }
          }
        }
      }
      if (hasRequired && !hasValue) {
        isValid = false;
      }

      if (field.conditions && Array.isArray(field.conditions)) {
        field.conditions.map((condition: any) => {
          condition.fieldset.map((set: any) => {
            set.fields = validateFields(set.fields);
          });
        });
      } else if (field.conditions && field.conditions.fieldset) {
        field.conditions.fieldset.forEach((set: any) => {
          set.fields = validateFields(set.fields);
        });
      }

      return {
        ...field,
        validate: hasRequired && !hasValue ? response : "",
      };
    });
  };

  setFieldset((prevFieldset: any) => {
    const updatedFieldset = { ...prevFieldset };
    if (updatedFieldset[set]) {
      updatedFieldset[set] = updatedFieldset[set].map((section: Fieldset) => ({
        ...section,
        fields: validateFields(section.fields),
      }));
    }
    return updatedFieldset;
  });
  return isValid;
};

export const extractFieldsValues = (fieldset: any) => {
  let values: any = {};

  const extractValues = (section: string, fields: Field[]) => {
    fields.forEach((field: Field) => {
      if (field.id) {
        if (typeof field.value !== "undefined" && field.value !== "") {
          if (field.id.includes("analysis_type|")) {
            //Temp
            values = {
              ...values,
              [section]: {
                ...(values[section] || {}),
                [field.id.split("|")[0]]: [field.id.split("|")[1]],
              },
            };
          } else if (field.id.includes("processing|")) {
            //Temp
            values = {
              ...values,
              [section]: {
                ...(values[section] || {}),
                processing_category: [field.id.split("|")[1]],
              },
            };
          } else {
            values = {
              ...values,
              [section]: {
                ...(values[section] || {}),
                [field.id]: field.value,
              },
            };
          }
        }
      }
      if (field.conditions && Array.isArray(field.conditions)) {
        field.conditions.map((condition: any) => {
          condition.fieldset.map((set: any) => {
            extractValues(section, set.fields);
          });
        });
      } else if (field.conditions && field.conditions.fieldset) {
        field.conditions.fieldset.forEach((set: any) => {
          extractValues(section, set.fields);
        });
      }
    });
  };

  Object.keys(fieldset).forEach((key) => {
    fieldset[key].forEach((section: Fieldset) => {
      extractValues(key, section.fields);
    });
  });
  return values;
};

export const extractFieldsFilters = (fieldset: any) => {
  let values: any = {};

  const extractLabels = (section: any, fields: any) => {
    fields.forEach((field: any) => {
      if (field.id) {
        if (typeof field.value !== "undefined" && field.value !== "") {
          if (typeof field.options !== "undefined") {
            const item = field.options.find(
              (c: any) => c.value === field.value
            );
            return (values[field.id] = item ? item.label : null);
          } else {
            return (values[field.id] = field.value);
          }
        }
      }
      if (field.conditions && field.conditions.fieldset) {
        field.conditions.fieldset.forEach((set: any) => {
          extractLabels(section, set.fields);
        });
      }
    });
  };

  Object.keys(fieldset).forEach((key) => {
    fieldset[key].forEach((section: any) => {
      extractLabels(key, section.fields);
    });
  });
  return values;
};

export const defaultValues = (
  set: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  updateValue(set, "analyst", `${user.id}`, setFieldset);

  if (set === "preparation") {
    updateValue(set, "valid_preparation", `NA`, setFieldset);
    updateValue(set, "amount_sample", "1.00E-05", setFieldset);
    updateValue(set, "start_date", new Date(), setFieldset);
  }

  if (set === "calculation") {
    const day = dayjs().format("DD/MM/YYYY");
    updateValue(set, "counting_date", `${day}`, setFieldset);
    updateText(set, "counting_date", `${day}`, setFieldset);
    updateValue(set, "laboratory", "17", setFieldset);
  }

  if (set === "counting") {
    updateValue(set, "applied_criterion", `5`, setFieldset);
    updateValue(set, "counting_date", new Date().toISOString(), setFieldset);
  }

  if (set === "management") {
    updateValue(set, "reception_analyst", `${user.id}`, setFieldset);
    updateValue(set, "retirement_analyst", `${user.id}`, setFieldset);
  }

  if (set === "conditioning") {
    updateValue(set, "sample_for_tritium", `Muestra para tritio`, setFieldset);
  }

  if (set === "sample") {
    const year = dayjs().format("YYYY");
    updateValue(set, "year", `${year}`, setFieldset);
  }
};

export const restartFieldset = (
  setName: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  setFieldset((prevFieldset: any) => {
    const updatedFieldset = { ...prevFieldset };
    updatedFieldset[setName] = updatedFieldset[setName].map((item: any) => {
      const updatedFields = item.fields.map((field: any) => {
        if (field.value !== undefined && typeof field.value !== "object") {
          return {
            ...field,
            value: "",
          };
        }
        return field;
      });

      return {
        ...item,
        fields: updatedFields,
      };
    });
    return updatedFieldset;
  });
};

export const getData = async <T = any>(endpoint: string) => {
  const response = await apiService<T>({
    endpoint,
    method: "GET" as const,
  });
  if (!response.success) {
    throw new Error(`HTTP error! status: ${response.error}`);
  }
  return response;
};

export const getDataFile = async <T = any>(
  endpoint: string,
  config: AxiosRequestConfig = {}
) => {
  const response = await apiService<T>({
    endpoint,
    method: "GET",
    ...config,
  });
  if (!response.success) {
    throw new Error(`HTTP error! status: ${response.error}`);
  }
  return response;
};

export const postDataFile = async <T = any>(
  endpoint: string,
  config: AxiosRequestConfig = {}
) => {
  const response = await apiService<T>({
    endpoint,
    method: "POST",
    ...config,
  });
  if (!response.success) {
    throw new Error(`HTTP error! status: ${response.error}`);
  }
  return response;
};

export const postDataFileDat = async <T = any>(
  endpoint: string,
  formData: any
) => {
  const response = await apiServiceDoc<T>({
    endpoint,
    method: "POST",
    data: formData,
  });

  if (!response.success) {
    throw new Error(`HTTP error! status: ${response.error}`);
  }
  return response;
};

export const putDataFile = async <T = any>(
  endpoint: string,
  data: any,
  config: AxiosRequestConfig = {}
) => {
  const response = await apiService<T>({
    endpoint,
    method: "PUT",
    data,
    ...config,
  });

  if (!response.success) {
    throw new Error(`HTTP error! status: ${response.error}`);
  }

  return response;
};

export const postData = async (endpoint: string, fields: any) => {
  const response = await apiService<{ message: string }>({
    endpoint,
    method: "POST",
    data: fields,
  });
  return response;
};

export const putData = async (endpoint: string, fields: any) => {
  const response = await apiService<{ message: string }>({
    endpoint,
    method: "PUT",
    data: fields,
  });
  return response;
};

export const deleteData = async (endpoint: string) => {
  const response = await apiService<{ message: string }>({
    endpoint,
    method: "DELETE",
  });

  if (!response.success) {
    throw new Error(`HTTP error! status: ${response.error}`);
  }

  return response;
};

export function transformDataForm(data: any) {
  let result: any = {};

  function processFields(fields: any) {
    fields.forEach((field: any) => {
      if (field.id && "value" in field) {
        if (field.type === "number") {
          result[field.id] = Number(field.value);
        } else {
          result[field.id] = field.value;
        }
      }
    });
  }

  for (let key in data) {
    if (Array.isArray(data[key])) {
      data[key].forEach((section: any) => {
        if (section.fields && Array.isArray(section.fields)) {
          processFields(section.fields);
        }
      });
    }
  }

  return result;
}
